/* @flow */

import { rem } from 'polished';

import { baseFontSize } from '@e180/ui/lib/token/typography';

export default {
  root: {
    cursor: 'pointer',
    maxWidth: '8em',
  },
  icon: {
    textAlign: 'center',
    fontSize: rem(10, baseFontSize),
    marginBottom: '3px',
  },
};
